import { styled } from 'opensolar-ui'
import { BetaChip } from './chip/BetaChip'

const HardwareBetaTagContainer = styled('span')(() => ({
  marginLeft: '0.5rem',
}))

const HardwareBetaTag = () => {
  return (
    <HardwareBetaTagContainer>
      <BetaChip color="primary" />
    </HardwareBetaTagContainer>
  )
}

export default HardwareBetaTag
